// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {FontAwesomeCode} from "../../types/font-awesome-code";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {Translations} from "@translations";

@Component({
	selector: "sim-admin-settings-input-list-to-editable-list",
	templateUrl: "./sim-admin-settings-input-list-to-editable-list.component.html",
	styleUrls: ["./sim-admin-settings-input-list-to-editable-list.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	standalone: false,
})
export class SimAdminSettingsInputListToEditableListComponent implements OnInit {
	T = Translations;

	@Input() noItemsText: string = this.T.SHARED_EDITABLE_LIST_NO_ITEMS;
	@Input() elements: any[];
	@Input() inlineEditOfItems: boolean = false;
	@Input() fontAwesomeCode: FontAwesomeCode = {
		fontSet: "fad",
		fontIcon: "fa-circle",
	};
	@Input() fontAwesomeCodeFunction: (args: any) => FontAwesomeCode;

	@Input() getElementViewValue: (element: unknown) => string = (element: unknown) => {
		if (typeof element === "string") {
			return element;
		}

		return "";
	};

	@Input() inEditMode: boolean = false;
	@Input() hasCreateButton = true;
	@Input() hasDeleteButton = true;
	@Input() showNoItems = true;

	onAddItemClicked = output<void>();
	onDeleteItemClicked = output<number>();
	valueChangedForElementEmitter = output<{
		index: number;
		value: string;
	}>();

	constructor() {}

	ngOnInit(): void {}

	trackByStringValue(index: number, option: string) {
		return index;
	}

	getAllElements() {
		return this.elements;
	}
}
